const styles = theme => ({
  root: {},
  tabContent: {
    padding: theme.spacing(2.5),
  },
})

export default styles
